import callApi from "helpers/callApi";

export const getAllBackgroundUsersList = async () => {
    return await callApi("referral_partner_authorise/bgvs_list");
  };